class SelectOptionsController {

    $onInit () {
        this.guest.validOptions = false;
        this.item.requiredOptions = 0;
        if (this.options) {
            this.options.forEach(group => {
                this.item.requiredOptions += group.selections;
            });
        }
    }

    toggle (param) {
        this[param] = !this[param];
    }

    selectOption (option) {
        if (!this.optionSelected(option)) {
            this.removeGroupOption(option);

            this.guest.item_children.push(option);

            this.checkValidity();
        }
    }

    removeGroupOption (option) {
        const index = this.guest.item_children.findIndex(item => {
            return item.group_id === option.group_id;
        });

        if (index > -1) {
            this.guest.item_children.splice(index, 1);
        }
    }

    optionSelected (option) {
        return !!this.guest.item_children.find(item => {
            return item.group_id === option.group_id
                && item.id === option.id;
        });
    }

    checkValidity () {
        if (this.optionsSelected === this.item.requiredOptions) {
            this.guest.validOptions = true;
            return;
        }

        this.guest.validOptions = false;
    }

    optionsSelected () {
        return this.guest.item_children.filter(item => {
            return item.type_name === 'OptionGroupOption';
        }).length || 0;
    }
}

SelectOptionsController.$inject = [];

export default SelectOptionsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/select.options.controller.js